function getStringLength(str) {
    let length = 0;
    for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        // 判断是否为全角字符（全角字符的Unicode编码范围）
        if (
            (charCode >= 0xff01 && charCode <= 0xff5e) || // 全角字符
            (charCode >= 0x3000 && charCode <= 0x303f) || // 中日韩符号和标点
            (charCode >= 0x4e00 && charCode <= 0x9fff) // 中日韩统一表意文字
        ) {
            length += 2;
        } else {
            length += 1;
        }
    }
    return length;
}
export const validateName: Function = (_rule, value, callback) => {
    if (!value.length) {
        return callback(new Error('名称不能为空'));
    }
    if (value.length > 40) {
        return callback(new Error('名称不能超过40个字符'));
    }
    return callback();
};
export const validateName100: Function = (_rule, value, callback) => {
    if (!value.length) {
        return callback(new Error('名称不能为空'));
    }
    const length = getStringLength(value);
    if (length > 100 || length <= 1) {
        return callback(new Error('仅支持2-100个字符'));
    }
    return callback();
};
export const validateRg: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('RG不能为空'));
    }
    return callback();
};
export const validateOncallCycle: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('请选择轮值周期'));
    }
    return callback();
};
export const validateOncallStart: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('请选择轮换时间点'));
    }
    return callback();
};
export const validateSendTime: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('请选择发送时间'));
    }
    return callback();
};
export const validateSendCycle: Function = (_rule, value, callback) => {
    if (!(value.length && value[0])) {
        return callback(new Error('请选择发送周期'));
    }
    return callback();
};
export default {
    validateName,
    validateRg,
    validateOncallCycle,
    validateOncallStart,
    validateSendTime,
    validateSendCycle
};
